module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Rachmaninoff’s song, for the first time in his early songs, the voice part takes the lead, with the piano playing a strong but supporting role. The verb in the first line means the sudden rising up in flight of a bird, or sudden beating of the heart. As the voice part rises and falls, Rachmaninoff finds trembling figures in the piano to suggest flight. The song bears his own signature. It is a slight but beautiful song, recognizably by Rachmaninoff and promising original songs to come.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("T")]), _vm._v("EXT")], 1), _vm._v(". "), _c('b', [_vm._v("Nikolái Porfírievich Grékov")]), _vm._v(", 1850s; published 1860 ("), _c('i', [_vm._v("Grekov")]), _vm._v(", p. 30). Untitled. Not set by any other composers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("ETER")], 1), _vm._v(". Ternary. Amphibrachs, alternating 4-foot and 3-foot lines, with feminine rhymes:")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("USIC")], 1), _vm._v(". Date uncertain. Pavel Lamm, the song’s editor, assumes 1890; "), _c('i', [_vm._v("Bortnikova")]), _vm._v(", 30, and "), _c('i', [_vm._v("LN 2")]), _vm._v(", 413, date it 1893, an opinion based on ink, paper, and handwriting. Without opus number. G Minor. 6/4, [Andante sostenuto] (editor’s brackets). For High Voice: d"), _c('sup', [_vm._v("1")]), _vm._v("–a"), _c('sup', [_vm._v("2")]), _vm._v(" flat. First published posthumously in Lamm’s "), _c('i', [_vm._v("Unpublished Vocal Works")]), _vm._v(", 1947. No dedication.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("R")]), _vm._v("ECORDINGS")], 1), _vm._v(". Korshunov, Piavko, Rodgers, Söderström, Suchkova, Timokhin.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "chtop",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "87%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('td'), _c('td', [_c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("Опять встрепенулось ты, сердце")])]), _vm._v(" "), _c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("Again you leapt, my heart")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nikolai Grekov (1807–1866) is nearly forgotten today, but in 1860 he was as well known as Fet and Polonsky, and many 19th-century Russian composers found attractive lyrics in his poetry: Mussorgsky’s fine early song “Where are you, little star?” (late 1850"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(") uses a shortened Grekov lyric, and Tchaikovsky wrote three of his most charming songs to lyrics by him (Songs 12, 26, and 28 in "), _c('i', [_vm._v("TCS")]), _vm._v(").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grekov was of the landed gentry like Fet and the Tolstoys, but his small estates in Tula and Kaluga were modest and did not bring in much income. He graduated from Moscow University in 1827, served a few years in a government job, then retired to the country, supporting his family by writing and translating Shakespeare, Goethe, Heine, Calderón, and others. His wife died young; this loss, and his memory of first love, inspired his best song lyrics, including “little star” and the present poem. His verse was musical; he wrote about love in outdoor settings that evoke the Russian countryside—subjects very close to Rachmaninoff’s heart. In one of his poems, he defines poetry this way: “In life, poetry is the "), _c('i', [_vm._v("rose")]), _vm._v(" in a garland of "), _c('i', [_vm._v("thorns")]), _vm._v(".” Both those images appear in the present text, as does the word "), _c('i', [_vm._v("music")]), _vm._v("; the lyric is about the poet’s heart reawakening to love and accepting life anew in both its beauty and its pain.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Опять встрепенулось ты")]), _vm._v(", "), _c('span', {
    staticClass: "font"
  }, [_vm._v("сердце")]), _vm._v(", "), _c('span', {
    staticClass: "font"
  }, [_vm._v("и снова")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("В душе моей вспыхнули грёзы")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И рвётся из груди кипучее слово")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И льются горячие слёзы")]), _vm._v("…")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И снятся опять ей всё звуки да звуки")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Всё музыки полные речи")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Да чёрные очи")]), _vm._v(", "), _c('span', {
    staticClass: "font"
  }, [_vm._v("да белые руки")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Да кудри")]), _vm._v(", "), _c('span', {
    staticClass: "font"
  }, [_vm._v("да белые плечи")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И снова душа отозваться готова")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("На всё")]), _vm._v(", "), _c('span', {
    staticClass: "font"
  }, [_vm._v("в чём есть тернья и розы")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И рвётся из груди кипучее слово")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И льются горячие слёзы")]), _vm._v("…")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Apját’ fstrepenúlas’ ty, sérttse, i snóva")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Again you beat faster, my heart, and again")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("V dushé majéj fspýkhnuli grjózy,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Bright dreams live in my soul,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I rvjótsa iz grúdi kipúcheje slóva,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And a passionate word flies from my breast,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("I l’jútsa garjáchije sljózy…")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("And hot tears pour out…")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("I snjátsa apját’ jej fsjo zvúki da zvúki,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("And my soul dreams of sounds, those sounds,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Vsjo múzyki pólnyje réchi,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Words you spoke full of music,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Da chórnyje óchi, da bélyje rúki,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And black eyes, and white hands,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Da kúdri, da bélyje pléchi.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("And curls, and white shoulders.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("I snóva dushá atazvátsa gatóva")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("And again my soul is ready to respond")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Na vsjó, f chom jest’ térn’ja i rózy,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("To everything that has thorns and roses,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I rvjótsa iz grúdi kipúcheje slóva,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And a passionate word flies from my breast,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("I l’jútsa garjáchije sljózy…")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("And hot tears pour out…")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("Again you beat faster, my heart, and as always")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left1"
  }, [_c('i', [_vm._v("The passionate words are the music…")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4c1176","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/015_Chapter_03.vue
// module id = 99
// module chunks = 0